<script>
    import R, {LOADER} from "../lib/requests";
    import app from '../stores/app';
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import PageHeader from "../components/PageHeader.svelte";
    import Breadcrumb from "../components/Breadcrumb.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";
    import DepartmentHotels from "./DepartmentHotels.svelte";
    import DepartmentUsers from "./DepartmentUsers.svelte";
    import AccountControl from "../components/controls/AccountControl.svelte";
    import InputGroupColor from "../components/controls/InputGroupColor.svelte";
    import PageNotFound from "../components/pages/PageNotFound.svelte";
    import {setFocusTo, randomColor, scrollTo, trim} from "../lib/lib";
    import {PAYMENT_TYPE} from "../lib/constants";

    export let departmentId = null;
    export let updateCallback;
    export let breadcrumb = [{name: 'Departments', link: `/app/department`}];

    export let account = null;

    // let accountId = null;
    let department = null;
    let pageTitle = '';
    let error = false;
    let link_url = null;


    const initialize = () => {
        if (account) {
            breadcrumb = [...breadcrumb, {id: 'account', name: account.name}];
        }

        scrollTo('top');

        if (departmentId == 0 || departmentId == 'create') {
            department = {
                id: 0,
                account_id: account ? account.id : null,
                color: randomColor(),
                link_code: null,
                name: '',
                contact_person: '',
                email: '',
                phone: '',
                mobile: '',
                address: '',
                notes: '',
                payment_method: PAYMENT_TYPE.CARD,
                is_active: 1,
                users: [],
                hotels: [],
            };
            departmentId = 0;
            pageTitle = "New Department";
            setFocusTo('departmentName');
        } else {
            load();
        }
    }

    const generateCode = () => {
        const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
        const groupLen = 4;
        const groups = 3;

        const bytes = new Uint8Array(groupLen * groups);
        crypto.getRandomValues(bytes);

        let result = [];
        for (let g = 0; g < groups; g++) {
            let part = "";
            for (let i = 0; i < groupLen; i++) {
                const index = bytes[g * groupLen + i] % chars.length;
                part += chars[index];
            }
            result.push(part);
        }

        department.link_code = result.join("-");
    }

    const load = () => {
        const onSuccess = result => {
            department = result;
            department.payment_method = ~~department.payment_method;
            pageTitle = department.name;

            link_url = department.link_code ? `${$app.department_reservation_url}/${department.link_code}` : null;

            setFocusTo('departmentName');
        }

        const onFailure = err => {
            error = true;
        };

        R.handle(R.department.details, departmentId, onSuccess, onFailure, LOADER.PAGE);
    };

    const save = () => {
        const onSuccess = result => {
            department = result;
            department.payment_method = ~~department.payment_method;
            departmentId = result.id;
            pageTitle = department.name;

            link_url = department.link_code ? `${$app.department_reservation_url}/${department.link_code}` : null;

            updateCallback(department);
            Notifier.showMessage("Department saved");
        }

        const onFailure = err => {
            if (err.code === 'object_related') {
                Alert.warning("Department", "Link code already assigned to an other department!");
                return;
            }
            Alert.warning("Department", err.message);
        };

        department.name = department.name.trim();
        if (!department.name) {
            Notifier.showError("Type the name of the department!");
            setFocusTo('departmentName');
            return;
        }

        if (!department.account_id || department.account_id == 0) {
            Notifier.showError("Select an account for this department!");
            return;
        }

        department.link_code = trim(department.link_code);
        if (department.link_code.length == 0) {
            // MUST BE NULL IF EMPTY
            department.link_code = null;
        }

        let action = department.id === 0 ? 'create' : 'edit';
        R.handle(R.department[action], department, onSuccess, onFailure, LOADER.POPUP);
    }

    const close = () => {
        updateCallback();
    }

    initialize();
</script>

{#if !account}
    <Breadcrumb {breadcrumb}/>
{/if}
{#if department}
    <PageHeader title="{ pageTitle }" subtitle="{ account ? account.name : '' }"/>
    <div class="row">
        <div class="col-xl-6 col-lg-7 col-md-6">
            <div class="panel border-default mb-5">
                <div class="panel-body panel-pad">
                    <div class="form-group">
                        <h5>Department name</h5>
                        <div class="input-group">
                            <input type="text" class="form-control" id="departmentName"
                                   bind:value="{ department.name }" autocomplete="off">
                            <InputGroupColor bind:value="{ department.color }"/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-6">
                            {#if !account}
                                <div class="form-group">
                                    <label>Account</label>
                                    <AccountControl bind:account="{ department.account }"
                                                    bind:accountId={ department.account_id }/>
                                </div>
                            {/if}
                            <div class="form-group">
                                <label>Contact person</label>
                                <input type="text" class="form-control" bind:value="{ department.contact_person }"
                                       autocomplete="off">
                            </div>
                            <div class="form-group">
                                <label>Address</label>
                                <input type="text" class="form-control" bind:value="{ department.address }"
                                       autocomplete="off">
                            </div>
                        </div>
                        <div class="col-xl-6">
                            <hr class="hidden-xl">

                            <div class="form-group">
                                <label>Phone</label>
                                <input type="tel" class="form-control" bind:value="{ department.phone }"
                                       autocomplete="off">
                            </div>
                            <div class="form-group">
                                <label>Mobile</label>
                                <input type="tel" class="form-control" bind:value="{ department.mobile }"
                                       autocomplete="off">
                            </div>
                            <div class="form-group">
                                <label>Email</label>
                                <input type="email" class="form-control" bind:value="{ department.email }"
                                       autocomplete="off">
                            </div>
                        </div>
                    </div>

                    <hr>
                    <div class="form-group">
                        <label>Link code</label>
                        <div class="input-group">
                            <input type="text" class="form-control" bind:value={department.link_code}>
                            <button class="btn btn-default" on:click={generateCode}>Generate</button>
                        </div>
                        {#if link_url}
                            <a href={link_url} target="_blank">{link_url}</a>
                        {/if}
                    </div>
                    {#if department.link_code}
                        <label>Payment method</label>
                        <select class="form-select" bind:value={department.payment_method}>
                            <option value={PAYMENT_TYPE.CARD}>Card</option>
                            <option value={PAYMENT_TYPE.BANK}>Bank deposit</option>
                        </select>
                    {/if}
                    <hr>
                    <div class="form-group">
                        <label>Notes</label>
                        <textarea class="form-control" bind:value="{ department.notes }"></textarea>
                    </div>
                    <div class="form-group">
                        <Checkbox label="Active department" bind:checked={ department.is_active }/>
                    </div>

                    <hr>
                    <div class="text-end">
                        {#if account}
                            <button class="btn btn-link" on:click="{ close }">back to account</button>
                        {/if}
                        <button class="btn btn-primary px-4" on:click="{ save }">SAVE</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-lg-5 col-md-6">
            <DepartmentHotels {department}/>
            <DepartmentUsers {department}/>
        </div>
    </div>
{/if}
{#if error}
    <PageNotFound message="Department not found!"/>
{/if}